import "core-js/modules/es.array.push.js";
import { transformStr3, getformListItemsdatas, setformdata, handleHttp, formateDate } from "@/utils/utils";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import flexible from '../../utils/flexible.js';
import guideTheme from '../../components/guideTheme';
export default {
  name: 'guideList',
  data() {
    return {
      list: [],
      exhibitionParams: {
        deptId: this.$route.query.fid || '44975',
        formId: '171924',
        page: 1,
        limit: 10,
        searchStr: ''
      },
      audioParams: {
        deptId: this.$route.query.fid || '44975',
        formId: '171925',
        page: 1,
        limit: 10,
        searchStr: '',
        orderBy: 'manualOrder'
      },
      detail: {},
      finished: false,
      realList: []
    };
  },
  components: {
    guideTheme
  },
  methods: {
    // 去详情页
    toDetail(item) {
      this.$router.push(`/guideDetail?aCode=${item.autoCode}&fid=${this.$route.query.fid}`);
    },
    // 获取展览的信息
    getExhibition() {
      let searchStr = {
        filters: [[{
          compt: "autonumber",
          express: '===',
          id: 10,
          range: null,
          val: this.$route.query.eCode
        }]],
        model: 0
      };
      this.exhibitionParams.searchStr = encodeURI(JSON.stringify(searchStr));
      this.$api.singleadvanceSearch(this.exhibitionParams).then(res => {
        let formatDataList = res.dataList.map((item, index) => {
          let itemformdata = item.formIdValueData;
          let itemformat = {};
          Object.keys(itemformdata).forEach(key => {
            itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
          });
          itemformat.image = itemformat.image.map(img => {
            return `https://museum.chaoxing.com/star3/origin/${img.objectId}.${img.suffix}`;
          });
          item.itemformdata = itemformat;
          return item.itemformdata;
        });
        this.detail = formatDataList[0];
        document.title = this.detail.name;
        let searchStr = {
          filters: [[{
            compt: "selectbox",
            express: 'match',
            alias: "exhibitionName",
            val: [this.detail.name],
            range: null
          }]],
          model: 0
        };
        this.audioParams.searchStr = encodeURI(JSON.stringify(searchStr));
        this.getList();
        this.$nextTick(() => {
          new Swiper(this.$refs.swiperNav, {
            slidesPerView: 'auto',
            centeredSlides: true,
            touchMoveStopPropagation: true,
            runCallbacksOnInit: false,
            observer: true,
            //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true,
            loop: true,
            pagination: {
              el: '.slide-pagination'
            }
          });
        });
      });
    },
    // 获取展览中讲解的列表
    getList(type, searchKey, moreIndex) {
      this.$api.singleadvanceSearch(this.audioParams).then(res => {
        if (res.totalRow > 0) {
          let formatDataList = res.dataList.map((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            itemformat.image = itemformat.image.map(img => {
              return `https://museum.chaoxing.com/star3/origin/${img.objectId}.${img.suffix}`;
            });
            itemformat.showMore = false;
            item.itemformdata = itemformat;
            return item.itemformdata;
          });
          if (this.audioParams.page == 1) {
            this.list = formatDataList;
          } else {
            this.list = this.list.concat(formatDataList);
          }
          this.realList = this.list.filter(i => {
            return !i.audioLevel || !i.audioLevel[0];
          });
          if (this.audioParams.page === res.totalPage) {
            this.finished = true;
            this.setChildren(1);
          }
          if (this.finished) return;
          this.audioParams.page++;
          this.getList();
        } else {
          this.list = [];
          this.finished = true;
        }
      });
    },
    // 获取下一层级
    setChildren(type) {
      if (!this.list.find(item => {
        return item.audioLevel;
      })) return;
      this.realList = this.realList.map((item, index) => {
        if (item.children && item.children.length) {
          item.children.map((child, childIndex) => {
            child.children = this.list.filter(i => {
              return i.audioLevel == child.explainObj;
            });
          });
        } else {
          item.children = this.list.filter(i => {
            return i.audioLevel == item.explainObj;
          });
        }
        item.length = !item.length ? item.children.length : item.children.length + item.length;
        return item;
      });
      if (type == 2) return;
      this.setChildren(type + 1);
      // this.realList = JSON.parse(JSON.stringify(list))
    },
    getChildrenList(item, index) {}
  },
  created() {
    flexible();
    this.getExhibition();
  },
  computed: {
    guideThemeColor() {
      return this.$store.state.guideTheme.color;
    }
  }
};